import { useEffect } from 'react';

/**
 * Opt the current route out of `desktopOnly.css`, which on viewports ≤ 1024 px
 * forces `body { min-width: 1024px }` and `html { font-size: 8.5px !important }`
 * so the entire app scales down like an image (the rest of the marketplace has
 * no mobile design). B2B pages have their own Figma mobile spec — they need
 * real reflow at small viewports, not a downscaled desktop layout.
 *
 * Mirrors the override pattern used by the saved-quote edit route.
 */
export const useOptOutOfDesktopOnly = () => {
    useEffect(() => {
        const html = document.documentElement;
        const body = document.body;
        const prevHtmlCssText = html.style.cssText;
        const prevBodyMinWidth = body.style.minWidth;

        html.style.setProperty('font-size', '16px', 'important');
        body.style.setProperty('min-width', '0', 'important');

        return () => {
            html.style.cssText = prevHtmlCssText;
            body.style.minWidth = prevBodyMinWidth;
        };
    }, []);
};
